module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-7.21bcab3e.png";